import { isProduction, isStaging } from './env';

// 默认线下环境
const SSOConfig = {
  clientId: '60b0d8def9',
  SSOHost: 'https://ssosv.it.test.sankuai.com',
  SSOCallbackUrl: '/api/carrier/sso/callback4931',
  SSOLogoutUrl: '/api/carrier/sso/logout4931',
  SSOUserInfoUrl: '/api/carrier/sso/whoami4931',
};

if (isProduction) {
  SSOConfig.clientId = 'a16056982c';
  SSOConfig.SSOHost = 'https://ssosv.sankuai.com';
  SSOConfig.SSOCallbackUrl = '/api/carrier/sso/callback4408';
  SSOConfig.SSOLogoutUrl = '/api/carrier/sso/logout4408';
  SSOConfig.SSOUserInfoUrl = '/api/carrier/sso/whoami4408';
}

if (isStaging) {
  SSOConfig.clientId = 'a16056982c';
  SSOConfig.SSOHost = 'https://ssosv.it.st.sankuai.com';
  SSOConfig.SSOCallbackUrl = '/api/carrier/sso/callback2210';
  SSOConfig.SSOLogoutUrl = '/api/carrier/sso/logout2210';
  SSOConfig.SSOUserInfoUrl = '/api/carrier/sso/whoami2210';
}

export default SSOConfig;
